import React from 'react';

import OptionBlock from '../../../../../../_ui/_blocks/Form/Inputs/OptionBlock/OptionBlock';

interface Props {
    checked?: boolean;
    className?: string;
    children: React.ReactNode;
}

/**
 * Renders a selectable card that has different visual states depending on it's checked and disabled states.
 * HeadlessUI doesn't provide a specific checkbox style to work with. However, it has been suggested to use
 * its Switch.Group component as an alternative.
 * @see https://headlessui.com/react/switch
 * @see https://github.com/tailwindlabs/headlessui/discussions/367#discussioncomment-6714131
 */
const CheckboxCard = ({ checked, className, children }: Props) => (
    <OptionBlock className={className} checked={checked} data-testid="checkbox-card">
        {children}
    </OptionBlock>
);

export default CheckboxCard;
